import React from 'react';
import { isFlaggedKeyStatus, keyAccountClass } from '../pages/order-management/quoteColors';

/**
 * Small pill showing a customer's key status (cms.customers.keyaccount) in the
 * same tier colors V1 uses everywhere else. Renders nothing for the AVERAGE
 * default or a blank value, so only customers that ARE key accounts stand out.
 */
export const KeyStatusBadge: React.FC<{ status: string | null | undefined; className?: string }> = ({
  status,
  className = '',
}) => {
  if (!isFlaggedKeyStatus(status)) return null;
  const label = (status ?? '').trim();
  return (
    <span
      className={`inline-block shrink-0 rounded px-1 py-px text-[0.625rem] font-semibold leading-tight whitespace-nowrap ${keyAccountClass(label)} ${className}`}
      title={`Key status: ${label}`}
    >
      {label}
    </span>
  );
};

export default KeyStatusBadge;
